// project import
import BannerRoutes from '../pages/banner/BannerRoute';
import GroupRoute from '../pages/group/GroupRoute';
import HighLightRoutes from '../pages/highlight/HighLightRoute';
import HighLightCategoryRoutes from '../pages/highlightcategory/HighLightCategoryRoute';
import LeagueRoutes from '../pages/leaguecategory/LeagueRoute';
import LiveRoutes from '../pages/live/LiveRoute';
import LiveCategoryRoutes from '../pages/livecategory/LiveCategoryRoute';
import NotiRoutes from '../pages/noti/NotiRoute';
import OddsRoutes from '../pages/odds/OddsRoute';
import TableRoutes from '../pages/table/TableRoute';
import TeamRoutes from '../pages/team/TeamRoute';
import TipsRoutes from '../pages/tips/TipsRoute';
import UserRoutes from '../pages/user/UserRoute';
import dashboard from './dashboard';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard,UserRoutes,GroupRoute,BannerRoutes,LeagueRoutes,TeamRoutes,LiveCategoryRoutes,LiveRoutes,HighLightCategoryRoutes,HighLightRoutes,TableRoutes,TipsRoutes,OddsRoutes,NotiRoutes]
};

export default menuItems;
